<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    persistent
    transition="dialog-bottom-transition"
    content-class="cover-generator-manual-full-screen-dialog"
  >
    <v-toolbar fixed height="56px" class="toolbar">
      <v-toolbar-items class="toolbar-side-icon">
        <!-- タイトルを中央に配置するために配置 -->
      </v-toolbar-items>

      <v-toolbar-title
        class="text-xs-center ml-0 toolbar-title"
        style="flex-grow: 1;"
      >
        操作方法
      </v-toolbar-title>

      <v-toolbar-items class="toolbar-side-icon">
        <v-btn flat icon color="primary" @click.native="onCloseDialog">
          <img src="../../../../assets/images/close_icon.svg" alt="close" />
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-card id="coverGeneratorManualFullScreenDialogTop" class="card">
      <section>
        <img
          src="../../../../assets/images/combook_binding/cover_generator_manual/top.png"
          alt="top"
        />

        <p>
          表紙作成機能の操作方法をご紹介します。<br />
          表紙を作成する手順や、きれいに仕上げるためのポイントなどをご確認ください。
        </p>

        <ol class="primary--text font-weight-bold">
          <li>
            <a
              href=""
              @click.prevent="
                goToStep('coverGeneratorManualFullScreenDialogStep1')
              "
              >写真をアップロード</a
            >
          </li>
          <li>
            <a
              href=""
              @click.prevent="
                goToStep('coverGeneratorManualFullScreenDialogStep2')
              "
              >写真の配置編集</a
            >
          </li>
          <li>
            <a
              href=""
              @click.prevent="
                goToStep('coverGeneratorManualFullScreenDialogStep3')
              "
              >デザインの切り替え</a
            >
          </li>
          <li>
            <a
              href=""
              @click.prevent="
                goToStep('coverGeneratorManualFullScreenDialogStep4')
              "
              >表紙画像の生成</a
            >
          </li>
        </ol>
      </section>

      <div class="divider-wrapper">
        <v-divider />
      </div>

      <section>
        <h3 id="coverGeneratorManualFullScreenDialogStep1" ref="step1">
          ステップ1.写真をアップロード
        </h3>

        <img
          src="../../../../assets/images/combook_binding/cover_generator_manual/step1.png"
          alt="step1"
        />

        <p>
          「写真を追加」を押して、お手持ちのスマートフォンやパソコンから写真を選んでください。
        </p>

        <h4>推奨サイズについて：</h4>

        <p>
          きれいな仕上がりに印刷するために、横幅1783px、縦幅1733px以上のサイズの写真を推奨しています。
        </p>
        <p>
          推奨サイズよりも小さい写真は、印刷時に画質が粗くなる可能性があるため、アップロードできない仕組みとなっております。恐れ入りますが、推奨サイズ以上写真をご用意ください。
        </p>
      </section>

      <div class="divider-wrapper">
        <v-divider />
      </div>

      <section>
        <h3 id="coverGeneratorManualFullScreenDialogStep2">
          ステップ2.写真の配置編集
        </h3>

        <p>
          表紙の中で、アップロードされた写真の配置の移動や拡大縮小を行えます。
        </p>
        <p>
          <span class="font-weight-bold">移動：</span><br />
          写真を指やマウスで動かして、写真の表示領域内で位置を調整できます。<br />
          スマホの場合：指でドラッグ<br />
          パソコンの場合：カーソルを合わせてドラッグ
        </p>
        <p>
          <span class="font-weight-bold">拡大縮小：</span><br />
          写真を指やマウスで拡大縮小できます。<br />
          スマホの場合：指でピンチ<br />
          パソコンの場合：カーソルを合わせてピンチ<br />
        </p>

        <h4>配置の際の注意点：</h4>

        <img
          src="../../../../assets/images/combook_binding/cover_generator_manual/step2.png"
          alt="step2"
        />

        <p>
          写真がページの端まできれいに印刷されるように、オレンジの点線（仕上がり位置）より外側まで広げて拡大・配置してください。
        </p>
        <p>
          <span class="font-weight-bold">白フチ防止エリアとは？</span><br />
          印刷後に紙を切り取る際、わずかなズレが生じることがあります。白フチ防止エリアは、切り取りのズレによってページの端に白い線（フチ）が出てしまうのを防ぐために、必要なエリアとなります。
        </p>
      </section>

      <div class="divider-wrapper">
        <v-divider />
      </div>

      <section>
        <h3 id="coverGeneratorManualFullScreenDialogStep3">
          ステップ3.デザインの切り替え
        </h3>

        <img
          src="../../../../assets/images/combook_binding/cover_generator_manual/step3.png"
          alt="step3"
        />

        <p>
          デザインの切り替えボタンをタップすることで、「パステル」「シンプル」のデザインを簡単に切り替えて表紙のイメージを確認できます。
        </p>
      </section>

      <div class="divider-wrapper">
        <v-divider />
      </div>

      <section>
        <h3 id="coverGeneratorManualFullScreenDialogStep4">
          ステップ4.表紙画像の生成
        </h3>

        <img
          src="../../../../assets/images/combook_binding/cover_generator_manual/step4.png"
          alt="step4"
        />

        <p>
          「次へ進む」ボタンを押すと、表紙の作成が始まります。データの生成に数秒間お時間をいただく場合がございます。生成完了後、製本の内容確認画面へ移動します。
        </p>
      </section>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goToStep(step) {
      // vue.refsを使いたかったが、うまくスクロールできないためgetElementByIdを使用
      const elem = document.getElementById(step);
      if (elem) {
        elem.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    onCloseDialog() {
      // 次回開いた時に先頭から始まるように、ダイアログを閉じた時に先頭にスクロールするしておく。
      const elem = document.getElementById(
        "coverGeneratorManualFullScreenDialogTop"
      );
      if (elem) {
        elem.scrollIntoView({ behavior: "instant", block: "start" });
      }

      this.$emit("close-dialog");
    }
  }
};
</script>

<style>
/* v-dialogはstyle scopedのスタイルを反映できないため、グローバルなstyleで対応 */
.cover-generator-manual-full-screen-dialog {
  scroll-padding-top: 72px; /* toolbarの高さを考慮して、スクロールの余白を追加 */
  overscroll-behavior: none;
}
</style>

<style scoped>
.toolbar {
  background-color: #ffffff;
  border-color: #0000001f;
  border-style: solid;
  border-width: 0 0 1px 0;
  box-shadow: none;
}
.toolbar-side-icon {
  width: 48px;
}
.toolbar-title {
  font-family: "Noto Sans JP";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
}
.card {
  padding-top: 56px !important; /* toolbarの高さを考慮して、パディングを追加 */
  background-color: #ffffff;
}
.card section {
  max-width: 443px;
  padding: 16px;
  margin: 0 auto;
}

.card .divider-wrapper {
  max-width: 443px;
  padding: 0 16px;
  margin: 0 auto 16px;
}

.card section h3,
.card section h4,
.card section p,
.card section ol,
.card section img {
  margin-bottom: 16px;
}
</style>
